import loadable from '@loadable/component';

import './HomePage.css';

export default loadable(() => {
  return import('./HomePage.jsx');
});
